<template>
  <div>
    <Line :data="chartData" />
  </div>
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
);

export default {
  components: {
    Line,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartData() {
      const labels = this.items.length
        ? this.items.map((item) => item.fecha)
        : [""];
      const datasets = this.datasets.length
        ? this.datasets
        : [
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: "rgba(200, 200, 200, 0.2)",
              borderColor: "rgba(200, 200, 200, 0.5)",
              borderWidth: 1,
              fill: false,
            },
          ];

      return {
        labels,
        datasets,
      };
    },
  },
};
</script>
